export type WireAmount = string | number | bigint;

export function toMinor(value: WireAmount): bigint {
  return typeof value === "bigint" ? value : BigInt(String(value));
}

export function formatMinor(value: bigint, signed = false): string {
  const sign = value < 0n ? "−" : signed && value > 0n ? "+" : "";
  const absolute = value < 0n ? -value : value;
  const rubles = absolute / 100n;
  const kopecks = absolute % 100n;
  const whole = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 }).format(rubles);
  return kopecks === 0n
    ? `${sign}${whole} ₽`
    : `${sign}${whole},${kopecks.toString().padStart(2, "0")} ₽`;
}

export function parseRubles(value: string): bigint {
  const normalized = value.trim().replace(/\s/g, "").replace(",", ".");
  if (!/^-?\d+(\.\d{1,2})?$/.test(normalized)) {
    throw new Error("Введите сумму в рублях, не более двух знаков после запятой");
  }
  const negative = normalized.startsWith("-");
  const unsigned = negative ? normalized.slice(1) : normalized;
  const [rubles, fraction = ""] = unsigned.split(".");
  const minor = BigInt(rubles) * 100n + BigInt(fraction.padEnd(2, "0"));
  return negative ? -minor : minor;
}

export function todayLocal(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
